import React from 'react';

/** A section the user can fold away. Open by default only when the list is short. */
export const Fold = ({ title, hint, defaultOpen, children }) => (
  <details open={defaultOpen} className="group rounded-lg border border-hairline">
    <summary className="flex cursor-pointer list-none items-center justify-between px-4 py-3">
      <span>
        <span className="text-sm font-semibold text-gray-800">{title}</span>
        {hint && <span className="ml-2 text-xs text-gray-500">{hint}</span>}
      </span>
      <span className="text-xs text-brand-700 group-open:hidden">Show</span>
      <span className="hidden text-xs text-brand-700 group-open:inline">Hide</span>
    </summary>
    <div className="border-t border-hairline p-4">{children}</div>
  </details>
);

export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export const TextCell = ({ value, onChange, label, className = '' }) => (
  <input
    aria-label={label}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className={`w-full rounded-md border border-hairline px-2 py-1 text-sm focus:border-brand-600 focus:outline-none ${className}`}
  />
);
